export  enum BudgetItemCalculation
{
    UNIDADXMESESXCOSTOUNITARIO = 1,
    UNIDADXCOSTOUNITARIO = 2,
}